import { createApiHook } from '../hooks';
import { scheduledReportsApiFactory } from './scheduledReportsApiFactory';

export const useScheduledReportsApi = createApiHook(scheduledReportsApiFactory);
